 // Contact.js
import React from 'react'
import Navbar from '../component/Navbar';
import ContactForm from '../component/form'
import Footer from '../component/Footer';

function Contact() {
  return (
    <div>
      <Navbar />
      <section className='FirstDiv ContactSection'>
        <p className='SmHeading SHeaderName'>
          CONTACT
        </p>
        <p className='BigHeading ContactBigHeader'>
          LET'S START<br/>
          SOMETHING.
        </p>
        <div className='SIWrapper' id='SIWrapper'>
          <div className='SmallInfo'>
            <p className='SmTxtSI'>
              EMAIL
            </p>
            <p className='BigTxtSI'>
              hello@tak-studio.com
            </p>
          </div>
          <div className='SmallInfo'>
            <p className='SmTxtSI'>
              LOCATION
            </p>
            <p className='BigTxtSI'>
              Berlin/Remote - Worldwide
            </p>
          </div>
          <div className='SmallInfo SIRight'>
            <p className='SmTxtSI'>
              RESPONSE TIME
            </p>
            <p className='BigTxtSI'>
              Within 24 hours
            </p>
          </div>
        </div>
      </section>
      <section className='FormSection'>
        <ContactForm/>  
      </section>
      <Footer/>
    </div>
  )
 }

 export default Contact
